// After a Spotify Web Player Connect API `PUT /me/player/play` call, the new
// tracks are queued on the device but the SDK's local state machine can stay
// in `paused` if it had been paused for a while (e.g. after our "No Music"
// auto-pause + 3 min session rotation). The Connect API succeeded, the device
// got the new track, yet no audio plays until the user presses Play.
//
// Repro confirmed in dev (2026-05-06, amzalegbarak@gmail.com): paused at
// 17:46:33 -> No Music -> session rotated -> new playlist a210171f became
// ready at 17:52:04 -> zero playback events. User had to press Play.
//
// Fix: after the play API call, give the SDK a moment to process the queued
// track, then if `getCurrentState()` still reports paused, call
// `player.resume()` to wake it. Resume is idempotent if already playing.
export async function ensurePlaybackStarted(player, opts = {}) {
  const delayMs = opts.delayMs ?? 800;
  if (!player || typeof player.getCurrentState !== 'function') {
    return false;
  }
  if (delayMs > 0) {
    await new Promise((resolve) => setTimeout(resolve, delayMs));
  }
  let state;
  try {
    state = await player.getCurrentState();
  } catch (e) {
    return false;
  }
  if (state && state.paused && typeof player.resume === 'function') {
    try {
      await player.resume();
      return true;
    } catch (e) {
      return false;
    }
  }
  return false;
}
